export var PRIMARY_ICON_WRAPPER_CLASS_PREFIX = 'PrimaryIconWrapper';